import React, { useEffect } from "react";
import OsharRealEstatePurchaseCard from "./OsharRealEstatePurchaseCard";
import "./oshar-real-estate-purchase-card.css";

/**
 * Thin modal shell: comic-library purchase card for Oshar VR real estate tiers.
 */
const RealEstateDetailModal = ({ item, onClose, onAuthRequired }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (!item) return null;

  return (
    <div
      className="oshar-re-modal-root oshar-re-modal-root--purchase-comic"
      role="dialog"
      aria-modal="true"
      aria-labelledby="oshar-re-purchase-title"
    >
      <button type="button" className="oshar-re-modal-backdrop" aria-label="Close" onClick={onClose} />
      <div className="oshar-re-modal oshar-re-modal--purchase-comic">
        <button type="button" className="oshar-re-modal__close" onClick={onClose} aria-label="Close dialog">
          ×
        </button>
        <OsharRealEstatePurchaseCard item={item} onClose={onClose} onAuthRequired={onAuthRequired} />
      </div>
    </div>
  );
};

export default RealEstateDetailModal;
